export default __webpack_public_path__ + "static/media/highest.61fb2f3e.jpg";